import HatchedBarWithStroke from './HatchedBarWithStroke';
export default HatchedBarWithStroke;
